import { TUI_ENGLISH_LANGUAGE_COUNTRIES } from '@taiga-ui/i18n/languages/english';
const TUI_UKRAINIAN_LANGUAGE_ADDON_COMMERCE = {
  cardNumber: ['Номер', 'Номер карти'],
  cardExpiry: ['Термін', 'Термін дії']
};
const TUI_UKRAINIAN_LANGUAGE_ADDON_EDITOR = {
  colorSelectorModeNames: ['Суцільний колір', 'Градієнт'],
  toolbarTools: {
    undo: 'Скасувати',
    redo: 'Повторити',
    font: 'Шрифт',
    fontStyle: 'Стиль шрифту',
    fontSize: 'Розмір шрифту',
    bold: 'Жирний',
    italic: 'Курсив',
    underline: 'Підкреслений',
    strikeThrough: 'Закреслений',
    justify: 'Вирівнювання',
    justifyLeft: 'Вирівняти текст за лівим краєм',
    justifyCenter: 'Вирівняти текст по центру',
    justifyRight: 'Вирівняти текст за правим краєм',
    justifyFull: 'Вирівняти за шириною',
    list: 'Списки',
    indent: 'Збільшити відступ',
    outdent: 'Зменшити відступ',
    unorderedList: 'Маркований список',
    orderedList: 'Нумерований список',
    quote: 'Цитата',
    foreColor: 'Колір: Текст',
    hiliteColor: 'Колір виділення',
    backColor: 'Колір фону',
    clear: 'Скинути форматування',
    link: 'Посилання',
    attach: 'Вставити файл',
    tex: 'Вставити формулу',
    code: 'Code',
    image: 'Вставити зображення',
    insertHorizontalRule: 'Розділювач',
    superscript: 'Надрядковий',
    subscript: 'Підрядковий',
    insertTable: 'Insert table',
    hiliteGroup: 'Hilite group',
    insertGroup: 'Insert group',
    removeGroup: 'Remove group',
    insertAnchor: 'Insert anchor',
    mergeCells: 'Merge cells',
    splitCells: 'Split cells',
    rowsColumnsManaging: 'Managing rows and columns',
    cellColor: 'Cell color',
    setDetails: 'Details',
    removeDetails: 'Remove details'
  },
  editorEditLink: {
    urlExample: 'example.com',
    anchorExample: 'anchor'
  },
  editorTableCommands: [['Insert column before', 'Insert column after'], ['Insert row before', 'Insert row after'], ['Delete column', 'Delete row']],
  editorCodeOptions: ['Code in the text', 'Code in block'],
  editorFontOptions: {
    small: 'Small',
    normal: 'Normal',
    large: 'Large',
    title: 'Title',
    subtitle: 'Subtitle'
  }
};
const TUI_UKRAINIAN_LANGUAGE_ADDON_TABLE = {
  showHideText: 'Показати/Приховати',
  paginationTexts: {
    pages: 'Сторінок',
    linesPerPage: 'Рядків на сторінку',
    of: 'з'
  }
};
const TUI_UKRAINIAN_LANGUAGE_CORE = {
  months: ['Січень', 'Лютий', 'Березень', 'Квітень', 'Травень', 'Червень', 'Липень', 'Серпень', 'Вересень', 'Жовтень', 'Листопад', 'Грудень'],
  close: 'Закрити',
  clear: 'Очистити',
  nothingFoundMessage: 'Нічого не знайдено',
  defaultErrorMessage: 'Поле заповнено невірно',
  spinTexts: ['Попередній', 'Наступний'],
  shortWeekDays: ['ПН', 'ВТ', 'СР', 'ЧТ', 'ПТ', 'СБ', 'НД'],
  // TODO: i18n replace with current language countries list
  countries: TUI_ENGLISH_LANGUAGE_COUNTRIES
};
const TUI_UKRAINIAN_LANGUAGE_KIT = {
  cancel: 'Скасувати',
  done: 'Готово',
  more: 'Ще',
  otherDate: 'Інша дата ...',
  showAll: 'Show all',
  hide: 'Hide',
  mobileCalendarTexts: ['Виберіть день', 'Виберіть період', 'Виберіть дні'],
  range: ['від', 'до'],
  countTexts: ['Плюс', 'Мінус'],
  time: {
    'HH:MM': 'ГГ:ХХ',
    'HH:MM AA': 'ГГ:ХХ АА',
    'HH:MM:SS': 'ГГ:ХХ:СС',
    'HH:MM:SS AA': 'ГГ:ХХ:СС АА',
    'HH:MM:SS.MSS': 'ГГ:ХХ:СС.МСС',
    'HH:MM:SS.MSS AA': 'ГГ:ХХ:СС.МСС АА'
  },
  dateTexts: {
    DMY: 'dd.mm.yyyy',
    MDY: 'mm.dd.yyyy',
    YMD: 'yyyy.mm.dd'
  },
  digitalInformationUnits: ['Б', 'КБ', 'МБ'],
  passwordTexts: ['Показати пароль', 'Приховати пароль'],
  copyTexts: ['Копіювати', 'Скопійовано'],
  shortCalendarMonths: ['Січ', 'Лют', 'Бер', 'Квіт', 'Трав', 'Черв', 'Лип', 'Серп', 'Верес', 'Жовт', 'Лист', 'Груд'],
  pagination: ['Попередня сторінка', 'Наступна сторінка'],
  fileTexts: {
    loadingError: 'Помилка завантаження',
    preview: 'Попередній перегляд',
    remove: 'Видалити'
  },
  inputFileTexts: {
    defaultLabelSingle: 'та перенесіть\u00A0його\u00A0сюди',
    defaultLabelMultiple: 'та перенесіть\u00A0їx\u00A0сюди',
    defaultLinkSingle: 'Виберіть файл',
    defaultLinkMultiple: 'Виберіть файли',
    maxSizeRejectionReason: 'Файл перевищує розмір ',
    formatRejectionReason: 'Невірний формат файлу',
    drop: 'Помістіть файл сюди',
    dropMultiple: 'Помістіть файли сюди'
  },
  multiSelectTexts: {
    all: 'Вибрати все',
    none: 'Не вибирати'
  },
  confirm: {
    yes: 'Так',
    no: 'Немає'
  },
  previewTexts: {
    rotate: 'Обертати'
  },
  zoomTexts: {
    zoomOut: 'Зменшення',
    zoomIn: 'Збільшувати',
    reset: 'Скинути'
  },
  phoneSearch: 'Введіть країну або код'
};
const TUI_UKRAINIAN_LANGUAGE_LAYOUT = {
  inputSearch: {
    popular: 'Popular',
    history: 'Recent',
    placeholder: 'Type query',
    hotkey: 'to search',
    all: 'All',
    empty: 'Nothing found'
  }
};
const TUI_UKRAINIAN_LANGUAGE = {
  name: 'ukrainian',
  ...TUI_UKRAINIAN_LANGUAGE_CORE,
  ...TUI_UKRAINIAN_LANGUAGE_KIT,
  ...TUI_UKRAINIAN_LANGUAGE_ADDON_COMMERCE,
  ...TUI_UKRAINIAN_LANGUAGE_ADDON_TABLE,
  ...TUI_UKRAINIAN_LANGUAGE_ADDON_EDITOR,
  ...TUI_UKRAINIAN_LANGUAGE_LAYOUT
};

/**
 * Generated bundle index. Do not edit.
 */

export { TUI_UKRAINIAN_LANGUAGE, TUI_UKRAINIAN_LANGUAGE_ADDON_COMMERCE, TUI_UKRAINIAN_LANGUAGE_ADDON_EDITOR, TUI_UKRAINIAN_LANGUAGE_ADDON_TABLE, TUI_UKRAINIAN_LANGUAGE_CORE, TUI_UKRAINIAN_LANGUAGE_KIT, TUI_UKRAINIAN_LANGUAGE_LAYOUT };
